'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var index_js = require('../utils/index.js');
require('../cursor/index.js');
require('prosemirror-transform');
require('prosemirror-model');
var prosemirrorState = require('prosemirror-state');
var prosemirrorView = require('prosemirror-view');
var preact = require('preact');
var prosemirrorCommands = require('prosemirror-commands');
var prosemirrorHistory = require('prosemirror-history');
var CodeMirror = _interopDefault(require('codemirror'));
require('codemirror/addon/selection/active-line');
require('codemirror/addon/edit/matchbrackets');
require('codemirror/lib/codemirror.css');
require('codemirror/mode/clike/clike.js');
require('codemirror/mode/css/css.js');
require('codemirror/mode/dart/dart.js');
require('codemirror/mode/elm/elm.js');
require('codemirror/mode/go/go.js');
require('codemirror/mode/groovy/groovy.js');
require('codemirror/mode/htmlmixed/htmlmixed.js');
require('codemirror/mode/http/http.js');
require('codemirror/mode/javascript/javascript.js');
require('codemirror/mode/jsx/jsx.js');
require('codemirror/mode/stex/stex.js');
require('codemirror/mode/lua/lua.js');
require('codemirror/mode/markdown/markdown.js');
require('codemirror/mode/nginx/nginx.js');
require('codemirror/mode/perl/perl.js');
require('codemirror/mode/php/php.js');
require('codemirror/mode/powershell/powershell.js');
require('codemirror/mode/python/python.js');
require('codemirror/mode/r/r.js');
require('codemirror/mode/ruby/ruby.js');
require('codemirror/mode/sass/sass.js');
require('codemirror/mode/shell/shell.js');
require('codemirror/mode/sql/sql.js');
require('codemirror/mode/stylus/stylus.js');
require('codemirror/mode/swift/swift.js');
require('codemirror/mode/vue/vue.js');
require('codemirror/mode/xml/xml.js');
require('codemirror/mode/yaml/yaml.js');
var keymap = _interopDefault(require('../keymap/index.js'));
var plantumlEncoder = _interopDefault(require('plantuml-encoder'));

const DEFAULT_LANGUAGE = 'Plain Text';
const DEFAULT_THEME = 'xq-light';
const DEFAULT_TITLE = '代码块';

// () -> string

function uuid() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const id = [];

  for (let i = 0; i < 8; i++) {
    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
  }

  return id.join('');
}

var schema = {
  nodes: {
    code_block: {
      group: 'block',
      content: 'text*',
      allowGapCursor: true,
      insertBlock: true,
      dragBlock: true,
      marks: '',
      attrs: {
        language: {
          default: DEFAULT_LANGUAGE
        },
        // 语言
        theme: {
          default: DEFAULT_THEME
        },
        // 皮肤
        title: {
          default: DEFAULT_TITLE
        },
        // 标题
        isExpand: {
          default: true
        },
        // 是否展开
        isCreate: {
          default: false
        },
        // 是否刚被创建
        dataDiffId: {
          default: null
        }
      },
      parseDOM: [{
        tag: 'div[class="ct-code"]',
        preserveWhitespace: 'full',

        getAttrs(dom) {
          const titleDOM = dom.querySelector('.title');
          const languageDOM = dom.querySelector('.language');
          const dataDiffId = dom.getAttribute('data-diff-id');
          const {
            language = languageDOM ? languageDOM.getAttribute('data-language') || DEFAULT_LANGUAGE : DEFAULT_LANGUAGE,
            theme = DEFAULT_THEME,
            title = titleDOM ? titleDOM.getAttribute('data-title') || DEFAULT_TITLE : DEFAULT_TITLE
          } = dom.dataset;
          let isExpand;

          if (dom.querySelector('.isNotExpand')) {
            isExpand = false;
          } else {
            isExpand = dom.getAttribute('data-expand') !== 'false';
          }

          return {
            language,
            theme,
            title,
            isExpand,
            dataDiffId
          };
        }

      }],

      toDOM(node) {
        const {
          language,
          theme,
          title,
          isExpand,
          dataDiffId
        } = node.attrs;
        const attrs = {
          class: 'ct-code',
          spellcheck: false,
          'data-language': language,
          'data-theme': theme,
          'data-title': title,
          'data-expand': isExpand,
          'data-diff-id': dataDiffId || `ct-diff-id-${uuid()}`
        };
        return ['div', attrs, ['pre', {}, ['code', 0]]];
      }

    }
  }
};

function insert() {
  return function (state, dispatch, view, trigger) {
    const {
      schema
    } = state;
    const node = schema.nodes.code_block.create({
      isCreate: true,
      language: localStorage.getItem('cmLanguage') || ''
    });
    const {
      transaction
    } = index_js.insertBlock(state, node);
    if (!transaction) return false;
    dispatch(transaction.scrollIntoView());
    if (typeof trigger === 'function') trigger('afterInsert', {
      draggable: true,
      braceWidth: 250
    });
    return true;
  };
}
function update(attrs, pos) {
  return (state, dispatch) => {
    const {
      tr,
      schema
    } = state;
    dispatch(tr.setNodeMarkup(pos, schema.nodes.code_block, attrs).scrollIntoView());
  };
}
function isInCode(state) {
  if (!state) return false;
  const {
    $from
  } = state.selection;
  const foundNode = index_js.findParentNode($from.path, node => node.type && node.type.spec.code);
  return !!foundNode;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ct-code-toolbar{display:flex;position:relative;width:100%;height:30px;padding-left:10px;align-items:center;background:#f2f2f2;box-sizing:border-box}.ct-code-toolbar .padding{height:100%;width:10px;cursor:pointer}.ct-code-toolbar .expand{width:24px;height:100%;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M375.967 310.026L28.207 642.81a89.34 89.34 0 0 0 0 130.17 99.323 99.323 0 0 0 136.058 0l347.76-332.657 347.759 332.785a99.323 99.323 0 0 0 136.057 0 89.34 89.34 0 0 0 0-130.17l-347.76-332.784-65.916-59.39a105.723 105.723 0 0 0-140.281 0l-65.917 59.39z' fill='%23747272'/%3E%3C/svg%3E\") no-repeat 50%;cursor:pointer;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.ct-code-toolbar .collapse{-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}.ct-code-toolbar .title{flex:1;line-height:30px;height:30px;font-size:12px;font-weight:700;color:#333;cursor:text;outline:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ct-code-toolbar .ct-code-lang-select-list{position:fixed;width:140px;max-height:360px;margin:0;padding:8px 0;background:#fff;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:4px;overflow-y:auto;list-style:none;z-index:11}.ct-code-toolbar .ct-code-lang-select-list::-webkit-scrollbar{background-color:#f5f5f5;width:6px;height:8px}.ct-code-toolbar .ct-code-lang-select-list::-webkit-scrollbar-thumb{border-radius:3px;background-color:#ddd}.ct-code-toolbar .list-item{height:24px;line-height:24px;padding-left:16px;font-size:12px;color:#333;cursor:pointer}.ct-code-toolbar .active,.ct-code-toolbar .list-item:hover{background:#f6f6f6}.ct-code-lang-select{width:140px;overflow:hidden;height:30px;line-height:30px}.ct-code-lang-select .lang{height:30px;padding-right:32px;font-family:Tahoma;font-size:12px;color:#999;text-align:right;cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ct-code-lang-select .lang:after{content:\"\";position:absolute;width:8px;height:8px;top:12px;margin:0 8px;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1638 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' id='mx_n_1513063069382' width='10.8' height='7.4'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M1595.802 262.758a160.563 160.563 0 0 0 31.539-167.936A145.203 145.203 0 0 0 1493.4 0H144.999A145.408 145.408 0 0 0 11.06 95.027 163.02 163.02 0 0 0 0 154.01c0 39.936 14.746 79.257 42.394 108.748L716.8 978.944c27.238 28.877 64.102 45.056 102.4 45.056 38.502 0 75.366-16.384 102.4-45.056l674.202-716.186z' fill='%23B0B0B0'/%3E%3C/svg%3E\") no-repeat 0 0;background-size:8px 8px;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.ct-code-lang-select .select-expand:after{-webkit-transform:rotate(180deg);transform:rotate(180deg)}";
styleInject(css);

// @jsx h
class Toolbar extends preact.Component {
  constructor(props) {
    super(props);

    this.toggleDisplay = () => {
      const isExpand = !this.state.isExpand;
      this.setState({
        isExpand
      });
      this.props.toggleDisplay(isExpand);
    };

    this.updateTitle = () => {
      const title = this.title.textContent;
      this.setState({
        title
      });
      this.props.updateTitle(title);
    };

    this.handleClick = e => {
      e.preventDefault();
      e.stopPropagation();
      const lang = e.target.textContent;

      if (lang === this.state.lang) {
        return;
      }

      this.props.changeLanguage(lang);
      this.setState({
        isShow: false,
        lang
      });
    };

    this.hideSelect = e => {
      const selectNode = e.target.closest('.ct-code-lang-select-list'); // 点击区域不是本select组件

      if (this.state.isShow && !selectNode) {
        this.setState({
          isShow: false
        });
      }
    };

    this.toggleShow = e => {
      e.preventDefault();
      e.stopPropagation();
      if (this.toolbar.offsetWidth < 100) return;
      const {
        left,
        top
      } = e.target.getBoundingClientRect();
      const ulTop = top + e.target.offsetHeight;
      this.setState({
        isShow: !this.state.isShow,
        left,
        top: ulTop
      });
    };

    this.state = {
      title: props.attrs.title || DEFAULT_TITLE,
      lang: props.attrs.language,
      isExpand: props.attrs.isExpand,
      isShow: false,
      left: 0,
      top: 0
    };
  }

  componentDidMount() {
    const pageWrapper = document.querySelector('body');
    pageWrapper.addEventListener('mousedown', this.hideSelect);
  }

  componentWillUnmount() {
    const pageWrapper = document.querySelector('body');
    pageWrapper.removeEventListener('mousedown', this.hideSelect);
  }

  render() {
    const {
      setSelection,
      languages
    } = this.props;
    const {
      lang,
      isExpand,
      isShow,
      title,
      left,
      top
    } = this.state;
    return preact.h("div", {
      className: "ct-code-toolbar",
      ref: refs => {
        this.toolbar = refs;
      }
    }, preact.h("div", {
      className: `expand ${isExpand ? '' : 'collapse'}`,
      onClick: this.toggleDisplay
    }), preact.h("div", {
      className: "title",
      contentEditable: true,
      dangerouslySetInnerHTML: {
        __html: title
      },
      ref: refs => {
        this.title = refs;
      },
      onFocus: setSelection,
      onBlur: this.updateTitle
    }), preact.h("div", {
      className: "ct-code-lang-select"
    }, preact.h("div", {
      className: `lang ${isShow ? 'select-expand' : ''}`,
      onClick: this.toggleShow
    }, lang)), isShow && preact.h("ul", {
      className: "ct-code-lang-select-list",
      ref: refs => {
        this.list = refs;
      },
      style: {
        left: `${left}px`,
        top: `${top}px`
      }
    }, languages.map(({
      name
    }) => preact.h("li", {
      className: `list-item ${lang === name ? 'active' : ''}`,
      key: name,
      onClick: this.handleClick
    }, name))));
  }

}

const languages = [{
  name: 'Plain Text',
  mime: 'text/plain',
  mode: 'null',
  ext: ['txt', 'text', 'conf', 'def', 'list', 'log']
}, {
  name: 'C',
  mime: 'text/x-csrc',
  mode: 'clike',
  ext: ['c', 'h', 'ino']
}, {
  name: 'C++',
  mime: 'text/x-c++src',
  mode: 'clike',
  ext: ['cpp', 'c++', 'cc', 'cxx', 'hpp', 'h++', 'hh', 'hxx'],
  alias: ['cpp']
}, {
  name: 'C#',
  mime: 'text/x-csharp',
  mode: 'clike',
  ext: ['cs'],
  alias: ['csharp']
}, {
  name: 'CSS',
  mime: 'text/css',
  mode: 'css',
  ext: ['css']
}, {
  name: 'Dart',
  mimes: ['application/dart', 'text/x-dart'],
  mode: 'dart',
  ext: ['dart']
}, {
  name: 'Elm',
  mime: 'text/x-elm',
  mode: 'elm',
  ext: ['elm']
}, {
  name: 'Go',
  mime: 'text/x-go',
  mode: 'go',
  ext: ['go']
}, {
  name: 'Groovy',
  mime: 'text/x-groovy',
  mode: 'groovy',
  ext: ['groovy', 'gradle'],
  file: /^Jenkinsfile$/
}, {
  name: 'HTML',
  mime: 'text/html',
  mode: 'htmlmixed',
  ext: ['html', 'htm', 'handlebars', 'hbs'],
  alias: ['xhtml']
}, {
  name: 'HTTP',
  mime: 'message/http',
  mode: 'http'
}, {
  name: 'Java',
  mime: 'text/x-java',
  mode: 'clike',
  ext: ['java']
}, {
  name: 'JavaScript',
  mimes: ['text/javascript', 'text/ecmascript', 'application/javascript', 'application/x-javascript', 'application/ecmascript'],
  mode: 'javascript',
  ext: ['js'],
  alias: ['ecmascript', 'js', 'node']
}, {
  name: 'JSON',
  mimes: ['application/json', 'application/x-json'],
  mode: 'javascript',
  ext: ['json', 'map'],
  alias: ['json5']
}, {
  name: 'JSX',
  mime: 'text/jsx',
  mode: 'jsx',
  ext: ['jsx']
}, {
  name: 'Kotlin',
  mime: 'text/x-kotlin',
  mode: 'clike',
  ext: ['kt']
}, {
  name: 'LaTeX',
  mime: 'text/x-latex',
  mode: 'stex',
  ext: ['text', 'ltx', 'tex'],
  alias: ['tex']
}, {
  name: 'Lua',
  mime: 'text/x-lua',
  mode: 'lua',
  ext: ['lua']
}, {
  name: 'Markdown',
  mime: 'text/x-markdown',
  mode: 'markdown',
  ext: ['markdown', 'md', 'mkd']
}, {
  name: 'Nginx',
  mime: 'text/x-nginx-conf',
  mode: 'nginx',
  file: /nginx.*\.conf$/i
}, {
  name: 'Objective-C',
  mime: 'text/x-objectivec',
  mode: 'clike',
  ext: ['m', 'mm'],
  alias: ['objective-c', 'objc']
}, {
  name: 'Perl',
  mime: 'text/x-perl',
  mode: 'perl',
  ext: ['pl', 'pm']
}, {
  name: 'PHP',
  mimes: ['text/x-php', 'application/x-httpd-php', 'application/x-httpd-php-open'],
  mode: 'php',
  ext: ['php', 'php3', 'php4', 'php5', 'php7', 'phtml']
}, {
  name: 'PowerShell',
  mime: 'application/x-powershell',
  mode: 'powershell',
  ext: ['ps1', 'psd1', 'psm1']
}, {
  name: 'Python',
  mime: 'text/x-python',
  mode: 'python',
  ext: ['BUILD', 'bzl', 'py', 'pyw'],
  file: /^(BUCK|BUILD)$/
}, {
  name: 'R',
  mime: 'text/x-rsrc',
  mode: 'r',
  ext: ['r', 'R'],
  alias: ['rscript']
}, {
  name: 'Ruby',
  mime: 'text/x-ruby',
  mode: 'ruby',
  ext: ['rb'],
  alias: ['jruby', 'macruby', 'rake', 'rb', 'rbx']
}, {
  name: 'Sass',
  mime: 'text/x-sass',
  mode: 'sass',
  ext: ['sass']
}, {
  name: 'Scala',
  mime: 'text/x-scala',
  mode: 'clike',
  ext: ['scala']
}, {
  name: 'Shell',
  mimes: ['text/x-sh', 'application/x-sh'],
  mode: 'shell',
  ext: ['sh', 'ksh', 'bash'],
  alias: ['bash', 'sh', 'zsh'],
  file: /^PKGBUILD$/
}, {
  name: 'SQL',
  mime: 'text/x-sql',
  mode: 'sql',
  ext: ['sql']
}, {
  name: 'Stylus',
  mime: 'text/x-styl',
  mode: 'stylus',
  ext: ['styl']
}, {
  name: 'Swift',
  mime: 'text/x-swift',
  mode: 'swift',
  ext: ['swift']
}, {
  name: 'Vue.js Component',
  mimes: ['script/x-vue', 'text/x-vue'],
  mode: 'vue',
  ext: ['vue']
}, {
  name: 'XML',
  mimes: ['application/xml', 'text/xml'],
  mode: 'xml',
  ext: ['xml', 'xsl', 'xsd', 'svg'],
  alias: ['rss', 'wsdl', 'xsd']
}, {
  name: 'YAML',
  mimes: ['text/x-yaml', 'text/yaml'],
  mode: 'yaml',
  ext: ['yaml', 'yml'],
  alias: ['yml']
}, {
  name: 'PlantUML',
  mode: 'plantuml'
}];
const modeMap = {};
languages.forEach(({
  name,
  mime,
  mode
}) => {
  if (mode === 'clike' || mode === 'sql') {
    modeMap[name.toLowerCase()] = Array.isArray(mime) ? mime[0] : mime;
  } else {
    modeMap[name.toLowerCase()] = mode;
  }
});
function getMode(language) {
  return modeMap[(language || '').toLowerCase()] || 'null';
}

var css$1 = ".cm-s-xq-light span.cm-keyword{line-height:1em;font-weight:700;color:#5a5cad}.cm-s-xq-light span.cm-atom{color:#6c8cd5}.cm-s-xq-light span.cm-number{color:#164}.cm-s-xq-light span.cm-def{text-decoration:underline}.cm-s-xq-light span.cm-type,.cm-s-xq-light span.cm-variable,.cm-s-xq-light span.cm-variable-2,.cm-s-xq-light span.cm-variable-3{color:#000}.cm-s-xq-light span.cm-comment{color:#0080ff;font-style:italic}.cm-s-xq-light span.cm-string{color:red}.cm-s-xq-light span.cm-meta{color:#ff0}.cm-s-xq-light span.cm-qualifier{color:grey}.cm-s-xq-light span.cm-builtin{color:#7ea656}.cm-s-xq-light span.cm-bracket{color:#cc7}.cm-s-xq-light span.cm-tag{color:#3f7f7f}.cm-s-xq-light span.cm-attribute{color:#7f007f}.cm-s-xq-light span.cm-error{color:red}.cm-s-xq-light .CodeMirror-activeline-background{background:#e8f2ff}.cm-s-xq-light .CodeMirror-matchingbracket{outline:1px solid grey;color:#000!important;background:#ff0}.CodeMirror{height:auto;background:#fcfcfc}.CodeMirror div{box-sizing:content-box}.CodeMirror pre{white-space:pre!important;padding:0 10px}.CodeMirror pre span{font-family:monospace}.CodeMirror .CodeMirror-sizer{margin-left:46px!important}.CodeMirror .CodeMirror-lines{padding:10px 0}.CodeMirror .CodeMirror-line{counter-increment:linenumber;margin:0}.CodeMirror .CodeMirror-line:before{content:counter(linenumber);position:absolute;display:block;left:-46px;width:32px;line-height:24px;text-align:right;font-size:12px;color:#9b9b9b}.cm-s-xq-light span.cm-def{text-decoration:none}.cm-s-xq-light span.cm-meta{color:red}.cm-s-xq-light span.cm-type{color:green}.CodeMirror-cursor{width:2px!important}";
styleInject(css$1);

const modeSet = new Set();
languages.forEach(({
  mode
}) => {
  if (!modeSet.has(mode) && mode !== 'null' && mode !== 'plantuml') {
    modeSet.add(mode);
  }
});

var css$2 = ".ct-code-selected{margin:5px 0;border:1px solid #0082a6;opacity:.7;border-radius:3px}.ct-code-selected .CodeMirror,.ct-code-selected .ct-code{margin:0}";
styleInject(css$2);

function computeChange(oldVal, newVal) {
  if (oldVal === newVal) return null;
  let start = 0;
  let oldEnd = oldVal.length;
  let newEnd = newVal.length;

  while (start < oldEnd && oldVal.charCodeAt(start) === newVal.charCodeAt(start)) ++start;

  while (oldEnd > start && newEnd > start && oldVal.charCodeAt(oldEnd - 1) === newVal.charCodeAt(newEnd - 1)) {
    oldEnd--;
    newEnd--;
  }

  return {
    from: start,
    to: oldEnd,
    text: newVal.slice(start, newEnd)
  };
}

class CodeBlockView {
  constructor(node, view, getPos, store) {
    this.updateAttrs = attrs => {
      const {
        state,
        dispatch
      } = this.view;
      const newAttrs = Object.assign({}, this.node.attrs, attrs);
      const command = update(newAttrs, this.getPos());
      command(state, dispatch);
    };

    this.toggleDisplay = isExpand => {
      const $cm = this.cm.getWrapperElement();
      this.cm.focus();

      if (isExpand) {
        $cm.style.cssText = 'height:auto !important';
        this.cm.refresh();
      } else {
        $cm.style.cssText = 'height:0 !important';
      }

      this.updateAttrs({
        isExpand
      });
    };

    this.updateTitle = title => {
      this.updateAttrs({
        title
      });
    };

    this.changeLanguage = language => {
      this.cm.setOption('mode', getMode(language));
      this.updateAttrs({
        language
      });
      this.cm.focus();
      localStorage.setItem('cmLanguage', language);
    };

    this.setTextSelection = () => {
      const {
        state,
        dispatch
      } = this.view;
      const {
        doc,
        tr
      } = state;
      const pos = this.getPos() + 1;
      const selection = prosemirrorState.TextSelection.create(doc, pos, pos);
      dispatch(tr.setSelection(selection));
    };

    // Store for later
    this.node = node;
    this.view = view;
    this.getPos = getPos;
    this.store = store;
    const {
      language: _language,
      theme,
      isCreate,
      dataDiffId
    } = this.node.attrs;
    const value = this.node.textContent; // Create a CodeMirror instance

    this.cm = new CodeMirror(null, {
      value,
      // lineNumbers: true, // 显示行号
      // foldGutter: true, // 代码可折叠
      // styleActiveLine: true, // 当前行高亮
      matchBrackets: true,
      // 括号高亮
      tabSize: 2,
      mode: getMode(_language),
      theme,
      // gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
      extraKeys: this.codeMirrorKeymap()
    });
    this.dom = this.createDom(); // CodeMirror needs to be in the DOM to properly initialize, so
    // schedule it to update itself

    setTimeout(() => {
      this.cm.refresh();
    }, 20); // This flag is used to avoid an update loop between the outer and
    // inner editor

    this.updating = false; // Propagate updates from the code editor to ProseMirror
    // this.cm.on('cursorActivity', () => {
    //   if (!this.updating) this.forwardSelection()
    // })

    this.cm.on('changes', () => {
      if (!this.updating) this.valueChanged();
    });
    this.cm.on('focus', () => {
      this.forwardSelection();
    }); // this.cm.on('blur', () => this.blur())

    this.cm.on('drop', (c, e) => {
      const htmlData = e.dataTransfer.getData('text/html');

      if (htmlData && htmlData[1] !== 'p' && htmlData[1] !== 'h') {
        e.stopPropagation();
        e.preventDefault();
        return false;
      }
    });
  }

  createDom() {
    const {
      attrs,
      attrs: {
        dataDiffId
      }
    } = this.node;
    const $cm = this.cm.getWrapperElement();

    if (!attrs.isExpand) {
      $cm.style.cssText = 'height:0 !important';
    } // 创建工具栏


    const $toolbar = document.createElement('div');
    preact.render(preact.h(Toolbar, {
      attrs: attrs,
      languages: languages,
      setSelection: this.setTextSelection,
      toggleDisplay: this.toggleDisplay,
      updateTitle: this.updateTitle,
      changeLanguage: this.changeLanguage
    }), $toolbar);
    const $code = document.createElement('div');
    $code.className = 'ct-code';

    if (dataDiffId) {
      $code.setAttribute('data-diff-id', dataDiffId);
    }

    $code.appendChild($toolbar);
    $code.appendChild($cm);
    return $code;
  }

  forwardSelection() {
    if (!this.cm.hasFocus()) return;
    const state = this.view.state;
    const selection = this.asProseMirrorSelection(state.doc);

    if (!selection.eq(state.selection)) {
      this.view.dispatch(state.tr.setSelection(selection));
    }
  }

  asProseMirrorSelection(doc) {
    const offset = this.getPos() + 1;
    const anchor = this.cm.indexFromPos(this.cm.getCursor('anchor')) + offset;
    const head = this.cm.indexFromPos(this.cm.getCursor('head')) + offset;
    return prosemirrorState.TextSelection.create(doc, anchor, head);
  }

  setSelection(anchor, head) {
    this.cm.focus();
    this.updating = true;
    this.cm.setSelection(this.cm.posFromIndex(anchor), this.cm.posFromIndex(head));
    this.updating = false;
  }

  valueChanged() {
    const change = computeChange(this.node.textContent, this.cm.getValue());

    if (change) {
      const {
        tr,
        schema
      } = this.view.state;
      const start = this.getPos() + 1;
      const from = start + change.from;
      const to = start + change.to;
      const content = change.text ? schema.text(change.text) : null;
      this.view.dispatch(tr.replaceWith(from, to, content));
    }
  }

  codeMirrorKeymap() {
    const view = this.view;
    const mod = /Mac/.test(navigator.platform) ? 'Cmd' : 'Ctrl';
    return CodeMirror.normalizeKeyMap({
      Up: () => this.maybeEscape('line', -1),
      Left: () => this.maybeEscape('char', -1),
      Down: () => this.maybeEscape('line', 1),
      Right: () => this.maybeEscape('char', 1),
      [`${mod}-Z`]: () => {
        prosemirrorHistory.undo(view.state, view.dispatch);
        this.store.trigger('afterInsert', {
          draggable: true
        });
      },
      [`${mod}-A`]: () => this.selectAll(),
      [`Shift-${mod}-Z`]: () => {
        prosemirrorHistory.redo(view.state, view.dispatch);
        this.store.trigger('afterInsert', {
          draggable: true
        });
      },
      [`Shift-${mod}-A`]: () => this.selectAllContent(),
      'Shift-Enter': () => {
        this.cm.execCommand('newlineAndIndent');
      },
      [`${mod}-Y`]: () => {
        prosemirrorHistory.redo(view.state, view.dispatch);
        this.store.trigger('afterInsert', {
          draggable: true
        });
      },
      'Ctrl-Enter': () => {
        if (prosemirrorCommands.exitCode(view.state, view.dispatch)) view.focus();
      }
    });
  }

  maybeEscape(unit, dir) {
    const pos = this.cm.getCursor();

    if (this.cm.somethingSelected() || pos.line !== (dir < 0 ? this.cm.firstLine() : this.cm.lastLine()) || unit === 'char' && pos.ch !== (dir < 0 ? 0 : this.cm.getLine(pos.line).length)) {
      return CodeMirror.Pass;
    }

    this.view.focus();
    const targetPos = this.getPos() + (dir < 0 ? 0 : this.node.nodeSize);
    const selection = prosemirrorState.Selection.near(this.view.state.doc.resolve(targetPos), dir);
    this.view.dispatch(this.view.state.tr.setSelection(selection).scrollIntoView());
    this.view.focus();
  }

  selectAllContent() {
    this.cm.focus();
    this.cm.execCommand('selectAll');
  }

  selectAll() {
    const {
      state,
      dispatch
    } = this.view;
    const allSelection = new prosemirrorState.AllSelection(state.doc);
    this.view.focus();
    dispatch(state.tr.setSelection(allSelection));
  }

  update(node) {
    if (node.type !== this.node.type) return false;
    this.node = node;
    const change = computeChange(this.cm.getValue(), node.textContent);

    if (change) {
      this.updating = true;
      this.cm.replaceRange(change.text, this.cm.posFromIndex(change.from), this.cm.posFromIndex(change.to));
      this.updating = false;
    }

    return true;
  }

  selectNode() {
    this.cm.focus();
  }

  stopEvent() {
    return true;
  } // destroy () {}


}

const createPlugin = store => {
  return new prosemirrorState.Plugin({
    props: {
      decorations: state => {
        const {
          selection,
          schema,
          doc
        } = state;
        const {
          from,
          to,
          $from
        } = selection;
        const {
          code_block
        } = schema.nodes;
        const node = doc.nodeAt(from);
        const code = index_js.findParentNode($from.path, item => item.type && item.type.name === "code_block");

        if (code) {
          const attrs = {
            class: "ct-code-show"
          };
          const deco = prosemirrorView.Decoration.node(code.pos, code.pos + code.node.nodeSize, attrs);
          return prosemirrorView.DecorationSet.create(state.doc, [deco]);
        }

        if (node && node.type === code_block && from + node.nodeSize === to) {
          const deco = prosemirrorView.Decoration.node(from, to, {
            nodeName: "div",
            class: "ct-code-selected"
          });
          return prosemirrorView.DecorationSet.create(doc, [deco]);
        }

        return prosemirrorView.DecorationSet.empty;
      },
      nodeViews: {
        code_block: (node, view, getPos) => new CodeBlockView(node, view, getPos, store)
      }
    }
  });
};

function arrowHandler(dir) {
  return (state, dispatch, view) => {
    if (state.selection.empty && view.endOfTextblock(dir)) {
      const side = dir === 'left' || dir === 'up' ? -1 : 1;
      const $head = state.selection.$head;
      const nextPos = prosemirrorState.Selection.near(state.doc.resolve(side > 0 ? $head.after() : $head.before()), side);

      if (nextPos.$head && nextPos.$head.parent.type.name === 'code_block') {
        dispatch(state.tr.setSelection(nextPos));
        return true;
      }
    }

    return false;
  };
}

function createKeymap() {
  return keymap({
    ArrowLeft: arrowHandler('left'),
    ArrowRight: arrowHandler('right'),
    ArrowUp: arrowHandler('up'),
    ArrowDown: arrowHandler('down')
  });
}

class CodeStore {
  init(editor) {
    this.trigger = editor.trigger;
  }

}

var css$3 = ".ct-code{min-width:233px;margin:5px 0;font-size:14px;border:1px solid #ddd;border-radius:2px 2px;background:#fcfcfc;font-family:monospace;line-height:21px}.ct-code .header{display:flex;position:relative;width:100%;height:30px;padding:0 10px;background:#f2f2f2;box-sizing:border-box}.ct-code .header .title{flex:1;padding-left:22px;line-height:30px;font-size:12px;font-weight:700;color:#333;cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ct-code .header .title:before{content:\"\";position:absolute;left:14px;top:11px;width:8px;height:8px;background:url(\"data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iOCIgaGVpZ2h0PSI4Ij48ZGVmcz48c3R5bGUvPjwvZGVmcz48cGF0aCBkPSJNMzc1Ljk2NyAzMTAuMDI2TDI4LjIwNyA2NDIuODFhODkuMzQgODkuMzQgMCAwIDAgMCAxMzAuMTcgOTkuMzIzIDk5LjMyMyAwIDAgMCAxMzYuMDU4IDBsMzQ3Ljc2LTMzMi42NTcgMzQ3Ljc1OSAzMzIuNzg1YTk5LjMyMyA5OS4zMjMgMCAwIDAgMTM2LjA1NyAwIDg5LjM0IDg5LjM0IDAgMCAwIDAtMTMwLjE3bC0zNDcuNzYtMzMyLjc4NC02NS45MTYtNTkuMzlhMTA1LjcyMyAxMDUuNzIzIDAgMCAwLTE0MC4yODEgMGwtNjUuOTE3IDU5LjM5eiIgZmlsbD0iIzc0NzI3MiIvPjwvc3ZnPg==\") no-repeat 0 0;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.ct-code .header .collapse:before{-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}.ct-code .header .icon-loading:before{border-radius:50%;border:1px solid #d5d5d5;border-bottom-color:transparent;background:none;transition:none;-webkit-animation:loading .8s linear infinite;animation:loading .8s linear infinite}.ct-code .header .language{width:120px;height:30px;line-height:30px;text-align:right;font-size:12px;color:#999}@-webkit-keyframes loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.ct-code[data-language=plantuml]:before{content:\"plantUML宏\";display:block;padding:10px 20px 0;font-size:12px;background:#fafafa}.ct-code[data-language=plantuml]>*{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none}@media print{.CodeMirror .CodeMirror-sizer{min-width:100%!important;max-width:100%!important}.CodeMirror .CodeMirror-sizer .CodeMirror-line{white-space:pre-wrap!important}}";
styleInject(css$3);

class CodeViewer extends preact.Component {
  constructor(props) {
    super();
    this.container = null;
    this.cm = null;

    this.initCodeViewer = () => {
      const {
        value = '',
        language,
        theme
      } = this.props.data;
      const {
        isMobile
      } = index_js.getSystemInfo();
      const inputStyle = isMobile ? 'textarea' : 'contenteditable';
      const readOnly = isMobile ? true : 'nocursor';
      const cm = new CodeMirror(this.container, {
        value,
        tabSize: 2,
        // Half-period in milliseconds used for cursor blinking.
        // The default blink rate is 530ms.
        // By setting this to zero, blinking can be disabled.
        // A negative value hides the cursor entirely.
        cursorBlinkRate: -1,
        inputStyle,
        readOnly,
        theme,
        // lineNumbers: true,
        matchBrackets: true,
        // 括号高亮
        mode: getMode(language)
      });
      this.cm = cm; // 阻止浏览态代码块还能够被剪切。。。

      cm.on('cut', (c, e) => {
        e.preventDefault();
      }); // 阻止移动端点击代码块唤起键盘

      this.$cm = cm.getWrapperElement();

      if (isMobile) {
        this.$cm.querySelector('textarea').setAttribute('disabled', 'true');
      }

      this.$cm.style.cssText = !this.state.isExpand ? 'height:0.1px !important' : 'height:auto !important';
      this.setState({
        isInit: true
      });
    };

    this.handleClick = () => {
      if (!this.$cm) {
        this.setState({
          isInit: false
        }, () => {
          // 不延迟loading效果出不来。。
          setTimeout(() => {
            this.initCodeViewer();
          }, 20);
        });
      } else {
        this.$cm.style.cssText = this.state.isExpand ? 'height:0.1px !important' : 'height:auto !important';
        this.setState({
          isExpand: !this.state.isExpand
        }, () => {
          if (this.cm) {
            this.cm.refresh();
          }
        });
      }
    };

    this.state = {
      isExpand: props.data.isExpand,
      isInit: null
    };
  }

  componentDidMount() {
    const {
      zoomCallback
    } = this.props;
    this.initCodeViewer();
    zoomCallback(this.$cm);
  }

  render() {
    const {
      isInit,
      isExpand
    } = this.state;
    const {
      title,
      language
    } = this.props.data;
    const iconClass = isInit === false ? 'icon-loading' : isExpand ? '' : 'collapse';
    return preact.h("div", null, preact.h("div", {
      key: "header",
      className: "header"
    }, preact.h("div", {
      className: `title ${iconClass}`,
      onClick: this.handleClick
    }, title), preact.h("div", {
      className: "language"
    }, language), !isExpand && preact.h("div", {
      className: "isNotExpand"
    })), preact.h("div", {
      key: "viewer",
      ref: refs => {
        this.container = refs;
      }
    }));
  }

}

function handler(node, zoomCallback) {
  const codeNode = node.querySelector('code');
  if (!codeNode) return;
  const {
    language = DEFAULT_LANGUAGE,
    theme = DEFAULT_THEME,
    title = DEFAULT_TITLE
  } = node.dataset;
  const isExpand = node.getAttribute('data-expand') !== 'false';
  const data = {
    language,
    theme,
    title,
    isExpand,
    value: codeNode.textContent
  };
  node.innerHTML = '';
  preact.render(preact.h(CodeViewer, {
    data: data,
    zoomCallback: zoomCallback
  }), node); // 清空data属性

  const attrs = ['data-language', 'data-theme', 'data-title', 'data-expand', 'spellcheck'];
  attrs.forEach(attr => {
    node.removeAttribute(attr);
  });
}
/**
 * 渲染 plantUML 图
 * @param plantUmlUrl string
 * @param node
 */


function renderPlantUML(plantUmlUrl = 'https://km.sankuai.com/plantuml/svg/', node) {
  const codeNode = node.querySelector('code');

  if (!codeNode) {
    return;
  }

  const content = codeNode.innerText;
  const encoded = plantumlEncoder.encode(content);
  const umlUrl = `${plantUmlUrl}${encoded}`;
  const newNode = document.createElement('span');
  newNode.setAttribute('class', 'ct-image');
  const imageNode = new Image();
  imageNode.setAttribute('src', umlUrl);
  imageNode.setAttribute('data-src', umlUrl);
  newNode.appendChild(imageNode);
  node.parentNode.replaceChild(newNode, node);
}

const codeToView = ({
  bodyWrapper,
  zoomCallback
}, {
  plantUmlUrl
} = {
  plantUmlUrl: 'http://www.plantuml.com/plantuml/svg/'
}) => {
  const codeBlockNodes = bodyWrapper.querySelectorAll('.ct-code');
  codeBlockNodes.forEach(node => {
    // 版本比对时，不显示代码高亮
    if (node.getAttribute('data-diff-ignore')) {
      return;
    }

    const language = node.getAttribute('data-language') || '';

    if (language.toLowerCase() === 'plantuml') {
      renderPlantUML(plantUmlUrl, node);
    } else {
      handler(node, zoomCallback);
    }
  });
};

class CodeModule {
  constructor() {
    this.name = "code";
    this.schema = schema;
    this.store = new CodeStore();
    this.commands = {
      insert
    };
    this.plugins = [createKeymap(), createPlugin(this.store)];
    this.utils = {
      isInCode
    };
  }

  init(editor) {
    this.store.init(editor);
  }

}
CodeModule.moduleName = "code";

exports.CodeModule = CodeModule;
exports.codeToView = codeToView;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/code/index.js